module.exports = __webpack_public_path__ + "static/media/full screen.71d75f83.svg";